import { useTranslation } from "react-i18next";
import {
  PlayCircleOutlined,
  SaveOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Button, Form, Layout, message, Modal } from "antd";
import { useWatch } from "antd/es/form/Form";
import { get, isEmpty } from "lodash";
import { createContext, FunctionComponent, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SettingLessonCourse from "../../../components/course-construction/content-course-construction/setting-lesson-course";
import SafeLink from "../../../components/link/SafeLink";
import PageHeader from "../../../components/page-header/PageHeader";
import { routesConfig } from "../../../config/routes";
import {
  ModeQuestion,
  QuestionProgressModeClick,
  QuestionTypeEnum,
  TypeCreateQuestion,
} from "../../../constants";
import { useDirty } from "../../../contexts/DirtyProvider";
import { usePreventRouteChange } from "../../../hooks/usePreventRouteChange";
import {
  getConfigBlockQuizAction,
  getConfigBlockQuizEvaluate,
  getConfigBlockQuizGeneral,
} from "../../../service/course-construct/settingLessonCourse";
import {
  createMoocCourseBlockQuiz,
  createMoocCourseBlockQuizConnect,
  updateMoocCourseBlockQuiz,
  updateMoocCourseBlockQuizConnect,
} from "../../../service/course-plan-managment/mooc-course-block-quiz/mooc-course-block-quiz";
import { HelpService } from "../../../service/helper.service";
import {
  saveQuizConnectVersionInQuestionBank,
  saveQuizVersionInQuestionBank,
} from "../../../service/question-bank";
import { globalStore, useAddLesson } from "../../../stores/stores";
import { VariableDefinitionsProps } from "../../../types/course";
import { mapAnsFEtoBE } from "../../../utils/arrays";
import { convertQuillToString } from "../../../utils/convertQuillToString";
import { extractTextFromHtml } from "../../../utils/format";
import {
  getIdIndexDB,
  saveToIndexDB,
} from "../../page-builder/grapesjs-service";
import AddSurvyCourse from "./add-survy-core/add-survy-core";
import "./add-survy.scss";
import useKeyword from "../../../hooks/useKeyword";

const { Content } = Layout;
const imgPath = "/images/";

type SurveyPlanPageProps = {
  isDisplaySetting?: boolean;
};

const ReachableContext = createContext<
  Partial<{ timeToPlay: string | null; completeTime: string | null }>
>({
  timeToPlay: null,
  completeTime: null,
});


const AddSurvyPage: FunctionComponent<SurveyPlanPageProps> = (props: any) => {
  const { t } = useTranslation();
  const config = {
    title: "Cảnh báo",
    okText: "Tiếp tục chỉnh sửa",
    className: "modal-warning--submit_lesson",
    content: (
      <>
        <p>
          {t("Thời gian thực hiện câu hỏi đang vượt quá thời gian thực hiện đánh giá.", "Thời gian thực hiện câu hỏi đang vượt quá thời gian thực hiện đánh giá.")}
        </p>
        <ReachableContext.Consumer>
          {(name: any) => {
            return (
              <ul>
                <li>{t("Tổng thời gian thực hiện câu hỏi :", "Tổng thời gian thực hiện câu hỏi :")} {name.timeToPlay} {t("phút", "phút")}</li>
                <li>{t("Thời gian thực hiện đánh giá:", "Thời gian thực hiện đánh giá:")} {name.completeTime} {t("phút", "phút")}</li>
              </ul>
            );
          }}
        </ReachableContext.Consumer>
      </>
    ),
  };
  
  const { isDisplaySetting } = props;
  const onRefreshQuizBlock = useAddLesson((state) => state.onRefreshQuizBlock);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);
  const reviewList = useAddLesson((state) => state.reviewList);
  const settingQuestion = useAddLesson((state) => state.settingQuestion);
  const currentQuestionInfo = useAddLesson(
    (state) => state.currentQuestionInfo
  );
  const question = useAddLesson((state) => state.question);
  const typeCreateQuestion = useAddLesson((state) => state.typeCreateQuestion);
  const setModeClick = useAddLesson((state) => state.setModeClick);
  const settingPopupQuestion = useAddLesson(
    (state) => state.settingPopupQuestion
  );
  const setCurrentIdQuestionAdd = useAddLesson(
    (state) => state.setCurrentIdQuestionAdd
  );
  const setDefaultTimeToPlay = useAddLesson(
    (state) => state.setDefaultTimeToPlay
  );
  const { setCurrentQuestionInfo } = useAddLesson();
  const quizInfoData = useAddLesson((state) => state.quizInfo);
  const [canSaveVersion, setCanSaveVersion] = useState<boolean>(false);

  const [settingLessonModal, setSettingLessonModal] = useState<any>(false);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [currentParentCourse, setCurrentParentCourse] = useState<string>();
  const [currentCourse, setCurrentCourse] = useState<any>();
  const [courseBlockId, setCourseBlockId] = useState<number>();
  const [generalSettingValue, setgeneralSettingValue] = useState<any>();
  const [actionSettingValue, setActionSettingValue] = useState<any>();
  const [evaluateSettingValue, setEvaluateSettingValue] = useState<any>();

  const helpService = new HelpService();
  const location = useLocation();
  const navigate = useNavigate();
  const { setDirty } = useDirty();
  const { confirmNavigation } = usePreventRouteChange();
  const [modal, contextHolder] = Modal.useModal();
  const [form] = Form.useForm();
  const valueCompletionTime = useWatch("completionTime", form);
  const searchParams = new URLSearchParams(location.search);
  const blockId = Number(searchParams.get("blockId"));
  const mode = searchParams.get("mode");
  const courseId = useParams()?.id;
  const unitId = useKeyword("unitId");

  const { personalInfo } = globalStore();

  useEffect(() => {
    getIdIndexDB("current-course", (val: any) => {
      setCurrentParentCourse(val.parent);
      setCurrentCourse({ id: val.id, name: val.name });
    });
  }, []);

  useEffect(() => {
    setCurrentCourse({ id: reviewList.id, name: reviewList.name });
  }, [reviewList]);

  useEffect(() => {
    if (blockId && mode === "setting") {
      if ((blockId && courseBlockId) || courseBlockId) {
        Promise.all([
          getConfigBlockQuizGeneral(blockId || courseBlockId),
          getConfigBlockQuizAction(blockId || courseBlockId),
          getConfigBlockQuizEvaluate(blockId || courseBlockId),
        ]).then((res) => {
          setgeneralSettingValue(res[0].data.data);
          setActionSettingValue(res[1].data.data);
          setEvaluateSettingValue(res[2].data.data);
          setCurrentParentCourse(res[0].data.data?.courseName);
        });
      }
    }
  }, [courseBlockId]);

  useEffect(() => {
    if (actionSettingValue) {
      const time = actionSettingValue.timeForQuiz;
      setDefaultTimeToPlay(time);
    }
  }, [actionSettingValue]);

  useEffect(() => {
    getIdIndexDB("courseBlockId", (val: any) => {
      if (val) {
        setCourseBlockId(JSON.parse(val));
      }
    });
  }, []);

  const createQuiz = async (dataReq: any) => {
    try {
      setLoadingSubmit(true);
      let apiRespone: any;
      if (question.type === QuestionTypeEnum.CONNECT) {
        apiRespone = await createMoocCourseBlockQuizConnect(dataReq);
      } else {
        apiRespone = await createMoocCourseBlockQuiz(dataReq);
      }
      const dataRespone = apiRespone.data;
      setModeClick(QuestionProgressModeClick.END);
      setCurrentIdQuestionAdd(dataRespone.body.id);
      saveToIndexDB("current-course", {
        currentId: dataReq.id,
        id: dataReq.id,
        name: currentCourse.name,
        parent: currentParentCourse,
      });
      helpService.successMessage(dataRespone.body.message);
      onRefreshQuizBlock();
      setCurrentQuestionInfo({});
    } catch (err: any) {
      helpService.errorMessage(err?.message || t("Tạo mới thất bại", "Tạo mới thất bại"));
      console.error(err);
    } finally {
      setTimeout(() => setLoadingSubmit(false), 1000);
    }
  };

  const updateQuiz = async (
    dataReq: any,
    submitType: "default" | "version"
  ) => {
    try {
      setLoadingSubmit(true);
      if (question.type === QuestionTypeEnum.CONNECT) {
        if (submitType === "default") {
          await updateMoocCourseBlockQuizConnect(dataReq); // Lưu thông thường
        } else {
          await saveQuizConnectVersionInQuestionBank(dataReq); //Lưu và đánh version cho quiz
        }
      } else {
        if (submitType === "default") {
          await updateMoocCourseBlockQuiz(dataReq); // Lưu thông thường
        } else {
          await saveQuizVersionInQuestionBank(dataReq); //Lưu và đánh version cho quiz
        }
      }
      setModeClick(QuestionProgressModeClick.END);
      helpService.successMessage("Cập nhật câu hỏi thành công");
      saveToIndexDB("current-course", {
        currentId: dataReq.id,
        id: dataReq.id,
        name: currentCourse.name,
        parent: currentParentCourse,
      });
      onRefreshQuizBlock();
      setCurrentQuestionInfo({});
    } catch (err: any) {
      helpService.errorMessage(err?.message || t("Cập nhật thất bại", "Cập nhật thất bại"));
      console.error(err);
    } finally {
      setLoadingSubmit(false);
    }
  };

  // Hàm để loại bỏ các thẻ HTML
  const stripHtml = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleSave = async (submitType: "default" | "version") => {
    let payload: any;

    if (typeCreateQuestion === TypeCreateQuestion.COURSEWARE) {
      payload = {
        id: question.id,
        orderNumber: 1,
        courseBlockGroupId: question.courseBlockGroupId,
        questionBankId: question.questionBankId,
        type: question.type,
        isLogUse: true,
        question: currentQuestionInfo.questionName,
        questionValue: convertQuillToString(currentQuestionInfo.questionName),
        answers: mapAnsFEtoBE(currentQuestionInfo, question.type as number),
        reminderText: currentQuestionInfo.reminderText,
        settingGeneral: {
          showForViewer: settingQuestion.isVisibleToViewers,
          requiredAnswer: settingQuestion.isRequiredAnswer,
          haveCorrectAnswer: settingQuestion.canEnterAnswer,
          isAutoMark: settingQuestion.canEnterAnswer,
          shuffleQuestion: settingQuestion.isRandomOrder,
          fileQuantity: settingQuestion.fileQuantity,
          fileCapacity: settingQuestion.fileCapacity,
          numberingType: settingQuestion.markNumber,
          timeToPlay: settingPopupQuestion.defaultQuestion
            ? settingQuestion.timeToPlay
            : 0,
          displayScoreCriteria: settingQuestion.displayScoreCriteria,
        },
        settingPoint: {
          isPerQuiz: settingQuestion.isSetScore4EachAns,
          correct: settingQuestion.scoreOfCorrect,
          incorrect: settingQuestion.scoreOfInCorrect,
        },
        settingHint: {
          isDisplayInstruction: settingQuestion.isShowGuide,
          content: settingQuestion.hintContent,
          uri: settingQuestion.uri,
          schema: settingQuestion.schema,
        },
        settingResponse: {
          isDisplayPerResponse: settingQuestion.isFeedback4EachAns,
          correct: settingQuestion.correctAns,
          incorrect: settingQuestion.incorrectAns,
          notYet: settingQuestion.notAnswer,
        },
      };
    }
    if (typeCreateQuestion === TypeCreateQuestion.SURVEY) {
      payload = {
        id: question.id,
        orderNumber: 1,
        courseBlockGroupId: question.courseBlockGroupId,
        type: question.type,
        question: currentQuestionInfo.questionName,
        answers: mapAnsFEtoBE(currentQuestionInfo, question.type as number),
        settingGeneral: {
          showForViewer: settingQuestion.isVisibleToViewers,
          requiredAnswer: settingQuestion.isRequiredAnswer,
          numberingType: settingQuestion.markNumber,
          fileQuantity: settingQuestion.fileQuantity,
          fileCapacity: settingQuestion.fileCapacity,
        },
      };
    }
    const strippedQuestionName = currentQuestionInfo.questionName;
    const checkArr = payload.answers.some((i: any) => isEmpty(i.filePath));

    if (payload.type === QuestionTypeEnum.NUMERICAL) {
      const tolerance =
        currentQuestionInfo?.tolerance ||
        currentQuestionInfo[0]?.tolerance ||
        0;
      payload.answers = [
        {
          ...mapAnsFEtoBE(currentQuestionInfo, question.type as number)[0],
          tolerance: tolerance,
        },
      ];
    }

    if (
      payload.type === QuestionTypeEnum.CALCULATED ||
      payload.type === QuestionTypeEnum.CALCULATED_SIMPLE ||
      payload.type === QuestionTypeEnum.CALCULATED_MULTI
    ) {
      const variableDefinitions =
        currentQuestionInfo?.variableDefinitions ||
        currentQuestionInfo[0]?.variableDefinitions;
      const tolerance =
        currentQuestionInfo?.tolerance ||
        currentQuestionInfo[0]?.tolerance ||
        0;
      const hasEmptyPredefinedValues = variableDefinitions?.some(
        (v: VariableDefinitionsProps) => isEmpty(v.predefinedValues)
      );

      if (hasEmptyPredefinedValues) {
        message.error(t("Vui thiết lập giá trị ngẫu nhiên cho câu hỏi", "Vui thiết lập giá trị ngẫu nhiên cho câu hỏi"));
        return;
      }

      payload.answers =
        payload.type === QuestionTypeEnum.CALCULATED_MULTI
          ? mapAnsFEtoBE(currentQuestionInfo, question.type as number)
              .map((quest: any) => {
                return {
                  ...quest,
                  variableDefinitions: variableDefinitions,
                  tolerance: tolerance,
                  content: extractTextFromHtml(quest?.content),
                };
              })
              .filter(
                (quest: any) =>
                  quest?.isTrue !== null && quest?.isTrue !== undefined
              )
          : [
              {
                ...mapAnsFEtoBE(
                  currentQuestionInfo,
                  question.type as number
                )[0],
                variableDefinitions: variableDefinitions,
                tolerance: tolerance,
                content: extractTextFromHtml(currentQuestionInfo[0]?.value),
              },
            ];
    }
    if (
      (QuestionTypeEnum.CHOOSE_VIDEO === payload.type ||
        QuestionTypeEnum.CHOOSE_MULTI_VIDEO === payload.type ||
        QuestionTypeEnum.CHOOSE_IMAGE === payload.type ||
        QuestionTypeEnum.CHOOSE_MULTI_IMAGE === payload.type) &&
      checkArr &&
      payload.answers.length !== 0
    ) {
      message.error(t("Không được bỏ trống các giá trị file và nội dung", "Không được bỏ trống các giá trị file và nội dung"));
    } else if (strippedQuestionName.length === 0) {
      message.error(t("Không được bỏ trống nội dung câu hỏi", "Không được bỏ trống nội dung câu hỏi"));
    } else {
      setDirty(false);

      if (modeQuestion === ModeQuestion.CREATE) {
        await createQuiz(payload);
      } else if (modeQuestion === ModeQuestion.UPDATE) {
        await updateQuiz(payload, submitType);
      }
    }
  };

  const saveSettingLesson = () => {
    form.submit();
    setSettingLessonModal(false);
  };

  const listBreadcrumb = [
    {
      title: t("Xây dựng khoá học", "Xây dựng khoá học"),
    },
    {
      title: (
        <>
          {typeCreateQuestion === TypeCreateQuestion.COURSEWARE ? (
            <SafeLink
              to={`/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}`}
            >
              <span>{t("Xây dựng Nội dung", "Xây dựng Nội dung")}</span>
            </SafeLink>
          ) : (
            <SafeLink
              to={`/${routesConfig.courseConstruction}/${routesConfig.surveyPlan}`}
            >
              <span>{t("Kế hoạch khảo sát", "Kế hoạch khảo sát")}</span>
            </SafeLink>
          )}
        </>
      ),
    },
    {
      title: (
        <a
          onClick={() => {
            confirmNavigation({ link: "" }, false, () => {
              navigate(-1);
            });
          }}
        >
          {currentParentCourse ? currentParentCourse : t("Chưa có tên", "Chưa có tên")}
        </a>
      ),
    },
    {
      title: get(currentCourse, "name", "Chưa có tên"),
    },
  ];

  const checkSubmit = (submitType: "default" | "version") => {
    if (valueCompletionTime * 60 < get(settingQuestion, "timeToPlay", 0)) {
      modal.warning(config);
    }
    if (
      valueCompletionTime * 60 > get(settingQuestion, "timeToPlay", 0) ||
      valueCompletionTime === undefined ||
      get(settingQuestion, "timeToPlay", 0) === 0
    ) {
      handleSave(submitType);
    }
  };

  const handleCheckPermission = () => {
    const userInfoInAuthors = quizInfoData.questionBank?.authors?.find(
      (user: any) => user.email === personalInfo.email
    );
    if (userInfoInAuthors) {
      userInfoInAuthors.permission === "2"
        ? setCanSaveVersion(false)
        : setCanSaveVersion(true);
    } else {
      quizInfoData.questionBank?.access === "1" ||
      quizInfoData.questionBank?.accessPermission === "2"
        ? setCanSaveVersion(false)
        : setCanSaveVersion(true);
    }
  };

  useEffect(() => {
    if (quizInfoData && Object.keys(quizInfoData).length > 0) {
      handleCheckPermission();
    }
  }, [quizInfoData]);

  return (
    <>
      <ReachableContext.Provider
        value={{
          timeToPlay: Math.floor(
            get(settingQuestion, "timeToPlay", 0) / 60
          ).toString(),
          completeTime: valueCompletionTime
            ? valueCompletionTime.toString()
            : "",
        }}
      >
        <Content className="add-lesson">
          <PageHeader
            title={get(currentCourse, "name", "Chưa có tên")}
            subTitle=""
            breadcrumb={true}
            listBreadcrumb={listBreadcrumb}
            arrowLeft={imgPath + "arrowLeft.svg"}
            positionItem="column"
            headerGroupButton={true}
            childrenGroupButton={
              <div className="button-container">
                <Button
                  icon={<PlayCircleOutlined />}
                  loading={loadingSubmit}
                  onClick={() => {
                    confirmNavigation({ link: "" }, false, () => {
                      saveToIndexDB("current-course", {
                        parent: currentParentCourse,
                        name: currentCourse.name,
                        currentId: question.id,
                        backUrl: `${location.pathname}${location.search}`,
                        backBreadCrumb: currentParentCourse,
                        selectedQuizz: question,
                      });
                      window.open(
                        `/${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.coursePreview}/${courseId}?unitId=${unitId}&blockId=${blockId}&screen=train`,
                        "_blank"
                      );
                    });
                  }}
                >
                  Trình phát
                </Button>
                {isDisplaySetting ? (
                  <></>
                ) : (
                  <Button
                    loading={loadingSubmit}
                    onClick={() => setSettingLessonModal(true)}
                  >
                    <SettingOutlined /> {t("Cài đặt", "Cài đặt")}
                  </Button>
                )}

                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={() => checkSubmit("default")}
                  loading={loadingSubmit}
                  disabled={modeQuestion === ""}
                >
                  {t("Lưu", "Lưu")}
                </Button>
                {/* {canSaveVersion ? (
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={() => checkSubmit("version")}
                    loading={loadingSubmit}
                    disabled={modeQuestion === ""}
                  >
                    {t("Lưu phiên bản", "Lưu phiên bản")}
                  </Button>
                ) : null} */}
              </div>
            }
          />
          <AddSurvyCourse activeHandleSave={() => handleSave("default")} />
          <Modal
            open={settingLessonModal}
            title={t("Cài đặt", "Cài đặt")}
            className="add-lesson-modal"
            closeIcon={true}
            onOk={saveSettingLesson}
            onCancel={() => setSettingLessonModal(false)}
            footer={null}
          >
            <SettingLessonCourse
              form={form}
              settingLessonModal={settingLessonModal}
              setSettingLessonModal={setSettingLessonModal}
              generalSettingValue={generalSettingValue}
              actionSettingValue={actionSettingValue}
              evaluateSettingValue={evaluateSettingValue}
            />
          </Modal>
          {contextHolder}
        </Content>
      </ReachableContext.Provider>
    </>
  );
};

export default AddSurvyPage;
